import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import * as Styled from './page-top-bar.style';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();
  return (
    <TopBarBase>
      <Styled.Title>
        <Typography variant="h6" component="h1">
          {t('pages.completed.title')}
        </Typography>
      </Styled.Title>
    </TopBarBase>
  );
};
